import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { FormValues } from "../types";
import { ComposeDisplay } from "../Components/ComposeDisplay";
import { useSenderInfo } from "../hooks/useSenderInfo";
import { useOutletContext } from "react-router-dom";
import { BulkMessageOutletContext } from "../SendBulkMessage";

export function ComposeReview() {
  const {
    getValues,
    formState: { errors },
    watch,
  } = useFormContext<FormValues>();
  const [sender, sendOption] = getValues(["sender", "sendOption"]);
  const { name: senderName, profilePhoto: senderProfilePhoto } =
    useSenderInfo();
  const { timeZone } = useOutletContext<BulkMessageOutletContext>();

  const messageParts = useMemo(() => {
    return watch("messageParts") || [];
  }, [watch]);

  return (
    <ComposeDisplay
      sender={sender}
      sendOption={sendOption}
      errors={errors}
      messageParts={messageParts}
      senderName={senderName}
      senderProfilePhoto={senderProfilePhoto}
      timeZone={timeZone}
    />
  );
}
